//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CardEditorial } from '@backmarket/design-system'
import isEmpty from 'lodash.isempty'

import { trackClick } from '@tracking/events'

import { DATA_SELECTOR_ATTRIBUTE_FOR_SEO } from './Card.constants'
import translations from './Card.translations'

export default {
  components: {
    CardEditorial,
  },
  props: {
    alt: {
      type: String,
      default: '',
    },
    category: {
      type: String,
      default: '',
    },
    guideId: {
      type: Number,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    imageRetina: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      required: true,
    },
    titleKicker: {
      type: String,
      default: '',
    },
    titleTag: {
      type: String,
      required: true,
    },
    trackingFunction: {
      type: Function,
      default: undefined,
    },
    link: {
      type: Object,
      default: () => {},
    },
    slug: {
      type: String,
      default: '',
    },
  },
  computed: {
    translations: () => translations,
    dataSelectorAttribute: () => DATA_SELECTOR_ATTRIBUTE_FOR_SEO,
    renderedImage() {
      return !isEmpty(this.imageRetina) ? this.imageRetina : this.image
    },
  },
  methods: {
    sendMarketingData() {
      return this.trackingFunction
        ? this.trackingFunction()
        : trackClick({
            name: this.title,
            zone: this.$route.name,
            value: {
              articleCategory: this.category,
            },
          })
    },
  },
}
